
import { useState, useEffect } from 'react';
import { getMyShorts } from '../../../services/reporterService';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Button, Typography
} from '@mui/material';

const MyShortsTable = () => {
  const [shorts, setShorts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchShorts = async () => {
    try {
      const res = await getMyShorts({ page, limit: 10, sort: '-createdAt' });
      setShorts(res.data);
      setTotalPages(res.totalPages || 1);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchShorts();
  }, [page]);

  return (
    <div>
      <Typography variant="h5" gutterBottom>My Shorts</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Video</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Likes</TableCell>
              <TableCell>Comments</TableCell>
              <TableCell>description </TableCell>
                <TableCell>Created At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {shorts.map(short => (
              <TableRow key={short._id}>
                <TableCell>
  <video
    src={short.videoUrl}
    controls
    autoPlay
    muted
    loop
    style={{
      width: '70px',
      height: '120px', 
      objectFit: 'cover', 
      borderRadius: '8px',
      display: 'block'
    }}
  />
</TableCell>

                <TableCell>{short.title}</TableCell>
                <TableCell>{short.status}</TableCell>
                <TableCell>{short.likesCount}</TableCell>
                <TableCell>{short.commentsCount}</TableCell>
                
                <TableCell>{short.description}</TableCell>
                <TableCell>{new Date(short.createdAt).toLocaleDateString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
        {page > 1 && <Button variant="contained" onClick={() => setPage(page - 1)}>Prev</Button>}
        {page < totalPages && <Button variant="contained" onClick={() => setPage(page + 1)}>Next</Button>}
      </div>
    </div>
  );
};

export default MyShortsTable;
